var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "change-owner-component",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__(
          "listing.batchComponents.ChangeOwnerComponent.change_owner"
        )
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.close
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c(
              "el-select",
              {
                staticClass: "wp-10",
                attrs: {
                  filterable: "",
                  remote: "",
                  placeholder: _vm.$t.__("common.actions.search"),
                  remoteMethod: _vm.autoCompleteStaff,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.staff,
                  callback: function($$v) {
                    _vm.staff = $$v
                  },
                  expression: "staff"
                }
              },
              _vm._l(_vm.staffs, function(item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.fullName, value: item.id }
                })
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: { click: _vm.close }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-2",
              attrs: {
                label: _vm.$t.__("common.actions.confirm"),
                type: "primary"
              },
              on: { click: _vm.save }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }